module.exports = __webpack_public_path__ + "img/mapa-ied.3ea584d8.png";